<template>
    <div>
    <app-toolbarcustom app_title="BoT" app_menu="home"></app-toolbarcustom>
    <v-card flat>
        <v-list two-line>
            <v-subheader></v-subheader>
            <template v-for="(item, index) in filteredposts">
                <v-list-item
                  :key="item.icon"
                  @click="GoTo(item.url)"
                >
                  <v-list-item-avatar>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                v-if="index + 1 < filteredposts.length"
                :key="index"
              ></v-divider>
           </template>
        </v-list>
    </v-card>
    </div>
</template>
<script>
    export default {
        data: () => ({
            loading: false,
            posts: [
                {icon: 'assignment', text: 'Booking', description: 'Booking Ruangan dll', url:'/booking',company: 'ALL'},
                {icon: 'gavel', text: 'Peraturan Perusahaan', description: 'Peraturan Perusahaan', url:'/company',company: 'ALL'},
                {icon: 'content_paste', text: 'SOP', description: 'Standard Operation Procedure', url:'/sop',company: 'ALL'},
                {icon: 'calculate', text: 'Kalkulator Profitabilitas', description: 'Profitabilitas', url:'/calculatepl',company: 'OPI'},
            ]
        }),
        computed: {
            filteredposts() {
                return this.posts.filter(post => {
                    if (this.$functions.UsersCompany() !== '') {
                        return post.company === 'ALL' || post.company === this.$functions.UsersCompany()
                    } else {
                        return post
                    }
                }
                )
            },
        },
        methods: {
            GoTo (url) {
                if (url === 'notavailable') {
                    alert('Coming Soon')
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
</script>